<template>
	<div @click="catchFocus" v-loading.fullscreen.lock="loading">
		<el-tabs v-model="activeName" type="card">
			<el-tab-pane label="扫码方式" name="扫码方式">
				<scan :quantity="currentQuantity" ref="scan" @updateLoading="updateLoading" @updateAllSize="updateAllSize" v-bind="$attrs" v-on="$listeners" :showFields="showFields.concat(['操作'])" @onlyUpdateLoading="onlyUpdateLoading"></scan>
			</el-tab-pane>
      <el-tab-pane label="手动勾选" name="手动勾选">
        <selected  ref="selected" @updateLoading="updateLoading" @updateAllSize="updateAllSize" :quantity="currentQuantity" v-bind="$attrs" v-on="$listeners" :showFields="showFields" @onlyUpdateLoading="onlyUpdateLoading"></selected>
      </el-tab-pane>
		</el-tabs>

		<div class="operate-buttons">
			<p class="info-tip">*批量操作可能需要较长时间，请耐心等待</p>
			<el-button type="primary" @click="submit" >提 交</el-button>
			<el-button @click="close" :disabled="loading" type="primary" plain>返 回</el-button>
		</div>
	</div>
</template>
<script>
import scan from './scan'
import selected from './selected'
export default {
  name: 'process-dialog',
  props: {
    quantity: {
      type: String
    }
  },
  components: {
    // [hgUploadFile.name]:hgUploadFile,
    // [lotOperateList.name]:lotOperateList,
    // [lotOperate.name]:lotOperate,
    // checkboxLotDetailList,
    scan, selected
  },
  data () {
    return {
      loading: false,
      notificeRefresh: false,
      activeName: '扫码方式',
      showFields: ['订单来源', '样本条码号', '受检者姓名', '受检者性别', '样本类型', '检测套餐', '生产条码号_input']
    }
  },
  computed: {
    currentQuantity () {
      // console.log('this.quantity---ooo', this.quantity)
      return this.quantity
    }
  },
  methods: {
    catchFocus (e) {
      document.querySelector('.scan-input').focus()
    },
    submit () {
      // this.loading = true
      if (this.activeName === '扫码方式') {
        this.$refs.scan.scanSubmit()
      } else {
        this.$refs.selected.selectedSubmit()
      }
    },
    // visibleHandle (val) {
    //   this.notificeRefresh && this.$emit('refresh')
    //   this.$emit('update:dialogVisible', val)
    // },
    close () {
      this.$router.push('/gene-lab-order')
    //   this.notificeRefresh && this.$emit('refresh')
    //   this.$emit('update:dialogVisible', false)
    },
    updateLoading (val) {
      this.onlyUpdateLoading(val)
      if (!val) {
        this.$emit('getCurrentStatusTotal')
        this.$refs.selected.reload()
      }
    },
    onlyUpdateLoading (val) {
      this.loading = val
    },
    updateAllSize (val) {
      this.$emit('updateAllSize', val)
    }
  }
}
</script>
<style lang="less">
</style>
